module.exports = __webpack_public_path__ + "static/img/can-mango.02daf28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-mango.png
// module id = YUY4
// module chunks = 0